import React from 'react';

import {Box} from 'views/components';
import {translate} from 'views/module';

import Introduction from './scenes/Introduction';
import Pulse from './scenes/benefits/Pulse';
import Monitoring from './scenes/benefits/Monitoring';
import Alerting from './scenes/benefits/Alerting';

import NextStep from 'views/scenes/product/util/NextStep';

const PulseScene = () => {
  return (
    <Box sx={{backgroundColor: 'color.white'}}>
      <Introduction/>
      <Box
        sx={{
          backgroundImage: {
            md: `url('/images/lines_blue.svg')`,
            xs: `linear-gradient(rgba(255,255,255,.4), rgba(255,255,255,.4)), url('/images/lines_blue.svg')`,
          },
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPositionX: {
            xs: 'calc( 100vw - 140px)',
            md: 'calc( 100vw - 348px)',
            xl: 'calc( ( 100vw - ( 100vw - 1600px ) / 2 ) - 368px )',
          },
          backgroundColor: 'trasnparent',
          backgroundSize: '131px auto',
          py: '80px',
        }}
      >
        <Pulse />
        <Monitoring />
        <Alerting />
      </Box>
      <NextStep
        previous={translate('pulse.Action.Previous')}
        next={translate('pulse.Action.Next')}
      />
    </Box>
  );
};

export default PulseScene;
